webpackJsonp([4568539161332],{

/***/ 1090:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0005_older_brother.jpg","type":"Unit","subtype":"Drunkard","cost":2,"ATK":2,"HP":2,"rules_text_1":null,"rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Older Brother","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"\"You said what about my little brother?\"","color":"Neutral","spec":null,"bottom":"Tech 0","rulings":[],"keywords":[],"slug":"older_brother"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"older_brother","keywords":[],"imageRegex":"/older_brother.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-older-brother-faf21f6b4e99f92a4201.js